export default __webpack_public_path__ + "static/media/demo1.899ec104.jpg";